import { useWindowSize } from '@/hooks/useWindowSize'

const SHOULD_STACK_IMAGES_AND_BULLETS_BREAKPOINT_IN_PX = 1000 // keep in sync with respond-to md size

export const useShouldStackImagesAndBullets = (): boolean => {
    const { width } = useWindowSize()
    return width <= SHOULD_STACK_IMAGES_AND_BULLETS_BREAKPOINT_IN_PX
}
